<template>
	<v-row>
		<v-col cols="12">
			<v-row>
				<v-col cols="12">
					<v-form ref="formProfile" role="form">
						<v-alert
							outlined
							type="warning"
							prominent
							border="left"
						>
							<span class="d-block ml-3">Perubahan data pribadi hanya bisa di lakukan oleh admin PT. Shine Beauty. Silakan hubungi Admin apabila ingin melakukan perubahan data pribadi Anda.</span>
						</v-alert>

						<v-card class="pa-3 elevation-0 rounded-xl pb-5 mb-3">
							<v-row class="pb-4">
								<v-col cols="12" sm="6" class="px-5 pb-0">
									<v-text-field label="Nama Lengkap" color="primary" prepend-inner-icon="mdi-account" hide-details="auto" v-model="member_name" :rules="rules.input" :disabled="true"></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" class="px-5 pb-0"></v-col>
								<v-col cols="12" sm="6" class="px-5 pb-0">
									<v-text-field label="Email" color="primary" class="input-regis" prepend-inner-icon="mdi-email" hide-details="auto" v-model="member_email" :rules="rules.email" :disabled="true" @change="changeInputData"></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" class="px-5 pb-0">
									<v-text-field label="Nomor Handphone" color="primary" class="input-regis" prepend-inner-icon="mdi-cellphone" hide-details="auto" v-model="member_mobilephone" :rules="rules.phone" :disabled="true" @change="changeInputData" @keypress="onlyNumber"></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" class="px-5 pb-0">
									<v-menu v-model="joinDate" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px">
										<template v-slot:activator="{ on, attrs }">
											<v-text-field label="Tanggal Gabung" color="primary" class="input-regis" prepend-inner-icon="mdi-calendar-check" hide-details="auto" readonly v-bind="attrs" v-on="on" :value="convertDate(data.member_join_datetime)" disabled></v-text-field>
										</template>
										<v-date-picker locale="id" first-day-of-week="0" color="primary" :max="today" @input="joinDate = false" hide-details="auto" v-model="data.member_join_datetime"></v-date-picker>
									</v-menu>
								</v-col>
								<v-col cols="12" sm="6" class="px-5 pb-0 mt-4 mb-2 d-flex flex-column flex-md-row align-md-center justify-md-space-between" v-if="false">
									<v-card-subtitle class="py-0 px-0 grey--text lighten-5"><v-icon dense class="mr-2">mdi-account-cog-outline</v-icon>Jenis Kelamin</v-card-subtitle>
									<v-radio-group v-model="member_gender" row hide-details="auto" class="ml-md-5 pl-md-5 mt-4 mt-md-0 pt-0" disabled :rules="rules.input">
										<v-radio label="Laki-laki" value="Laki-laki"></v-radio>
										<v-radio label="Perempuan" value="Perempuan"></v-radio>
									</v-radio-group>
								</v-col>
								<v-col cols="12" sm="6" class="px-5 pb-0">
									<v-text-field label="Jenis Kelamin" color="primary" class="input-regis" prepend-inner-icon="mdi-account-cog-outline" hide-details="auto" v-model="member_gender" :rules="rules.input" disabled></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" class="px-5 pb-0">
									<v-text-field label="Tempat Lahir" color="primary" class="input-regis" prepend-inner-icon="mdi-home-city" hide-details="auto" v-model="member_birth_place" :rules="rules.input" disabled></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" class="px-5 pb-0">
									<v-menu v-model="bornDate" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px">
										<template v-slot:activator="{ on, attrs }">
											<v-text-field label="Tanggal Lahir" color="primary" class="input-regis" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" :value="convertDate(member_birth_date)" :rules="rules.input" disabled></v-text-field>
										</template>
										<v-date-picker locale="id" first-day-of-week="0" color="primary" :max="today" @input="bornDate = false" hide-details="auto" v-model="member_birth_date"></v-date-picker>
									</v-menu>
								</v-col>
							</v-row>
						</v-card>

						<v-card class="pa-3 elevation-0 rounded-xl pb-5 mb-3">
							<v-row>
								<!-- Info Identitas -->
								<v-col cols="12" sm="12" lg="4" class="pb-0">
									<v-card outlined class="pa-3 elevation-0 rounded-xl pb-5 mb-3">
										<v-row>
											<v-col cols="12" sm="12" class="">
												<v-text-field label="Nomor Identitas" color="primary" class="input-regis" @keypress="onlyNumber" prepend-inner-icon="mdi-card-account-details" hide-details="auto" v-model="member_identity_no" :disabled="(data.member_identity_no || !isEditing) ? true : false"></v-text-field>
											</v-col>
											<v-col cols="12" class="d-none">
												<v-file-input
													id="uploadIdentity"
													hide-input
													accept="image/png,image/jpeg,image/jpg,image/x-png"
													prepend-icon="mdi-camera"
													label="Pilih gambar"
													v-model="identity_image_upload"
													:rules="rules.fileidentity"
													@change="previewImageIdentity($event)"></v-file-input>
											</v-col>
											<v-col cols="12" class="d-flex align-center justify-space-between flex-column">
												<div style="display: block; position: relative; min-width: 160px; width: auto; max-width: 100%; margin: 0 auto;">
													<v-img max-width="100%" width="auto" height="180px" class="rounded-lg d-block mx-auto" :src="(identity_image_url) ? identity_image_url : 'assets/image/no-image.png'" style="border: 1px solid #ddd;"></v-img>
													<v-btn
														elevation="3"
														fab
														icon
														outlined
														raised
														rounded
														small
														class="btn-zoom"
														@click="dialogZoomOpen(identity_image_url)"
														v-if="identity_image_upload || data.member_identity_image != ''"
													><v-icon color="#fff">mdi-magnify-plus-outline</v-icon></v-btn>
													<v-btn
														elevation="3"
														color="error"
														fab
														icon
														outlined
														raised
														rounded
														x-small
														style="position: absolute; top: -10px; right: -10px;background: #fff;"
														@click="clearIdentityImg"
														v-if="identity_image_upload"
													><v-icon>mdi-close</v-icon></v-btn>
												</div>

												<v-btn
													depressed
													block
													outlined
													height="40px"
													:color="(!identity_image_upload) ? (errorValidation['identity_image'] && errorValidation['identity_image'] !== undefined) ? 'red' : 'primary' : '#408285'"
													class="text-capitalize mt-4"
													tabindex="13"
													:loading="btn_loading"
													:disabled="(identity_image_upload || !isEditing) ? true : false"
													@click="openIdentityUpload"
												>
													<!-- v-if="!data.member_identity_image" -->
													<v-icon>mdi-file-upload-outline</v-icon>
													<span class="pr-2 ms-2">Upload Foto Identitas</span>
												</v-btn>

												<small class="red--text mt-1" v-if="(errorValidation !== undefined && errorValidation['identity_image'] !== undefined) || !identity_image_upload">
													{{ (errorValidation !== undefined && errorValidation['identity_image'] !== undefined) ? errorValidation['identity_image'] : (!identity_image_upload) ? '' : '' }}
												</small>
											</v-col>
										</v-row>
									</v-card>
								</v-col>

								<!-- Info KK -->
								<v-col cols="12" sm="12" lg="4" class="pb-0">
									<v-card outlined class="pa-3 elevation-0 rounded-xl pb-5 mb-3">
										<v-row>
											<v-col cols="12" sm="12" class="">
												<v-text-field label="Nomor Kartu Keluarga" color="primary" class="input-regis" @keypress="onlyNumber" prepend-inner-icon="mdi-card-account-details" hide-details="auto" v-model="member_kk_no" :disabled="((data.member_kk_no !== '' && data.member_kk_no !== null) || !isEditing) ? true : false"></v-text-field>
											</v-col>

											<v-col cols="12" class="d-none">
												<v-file-input
													id="uploadKK"
													hide-input
													accept="image/png,image/jpeg,image/jpg,image/x-png"
													prepend-icon="mdi-camera"
													label="Pilih gambar"
													v-model="kk_image_upload"
													:rules="rules.filekk"
													@change="previewImageKk($event)"></v-file-input>
											</v-col>

											<v-col cols="12" class="d-flex align-center justify-space-between flex-column">
												<div style="display: block; position: relative; min-width: 160px; width: auto; max-width: 100%; margin: 0 auto;">
													<v-img max-width="100%" width="auto" height="180px" class="rounded-lg d-block mx-auto" :src="(kk_image_url) ? kk_image_url : 'assets/image/no-image.png'" style="border: 1px solid #ddd;"></v-img>
													<v-btn
														elevation="3"
														fab
														icon
														outlined
														raised
														rounded
														small
														class="btn-zoom"
														@click="dialogZoomOpen(kk_image_url)"
														v-if="kk_image_upload || data.member_kk_image != ''"
													><v-icon color="#fff">mdi-magnify-plus-outline</v-icon></v-btn>
													<v-btn
														elevation="3"
														color="error"
														fab
														icon
														outlined
														raised
														rounded
														x-small
														style="position: absolute; top: -10px; right: -10px;background: #fff;"
														@click="clearKkImg"
														v-if="kk_image_upload"
													><v-icon>mdi-close</v-icon></v-btn>
												</div>

												<v-btn
													depressed
													block
													outlined
													height="40px"
													:color="(!kk_image_upload) ? (errorValidation['kk_image'] && errorValidation['kk_image'] !== undefined) ? 'red' : 'primary' : '#408285'"
													class="text-capitalize mt-4"
													tabindex="13"
													:loading="btn_loading"
													:disabled="(kk_image_upload || !isEditing) ? true : false"
													@click="openKkUpload"
													v-if="!data.member_kk_image"
												>
													<v-icon>mdi-file-upload-outline</v-icon>
													<span class="pr-2 ms-2">Upload Foto KK</span>
												</v-btn>

												<small class="red--text mt-1" v-if="(errorValidation !== undefined && errorValidation['kk_image'] !== undefined) || !kk_image_upload">
													{{ (errorValidation !== undefined && errorValidation['kk_image'] !== undefined) ? errorValidation['kk_image'] : (!kk_image_upload) ? '' : '' }}
												</small>
											</v-col>
										</v-row>
									</v-card>
								</v-col>

								<!-- Info NPWP -->
								<v-col cols="12" sm="12" lg="4" class="pb-0">
									<v-card outlined class="pa-3 elevation-0 rounded-xl pb-5 mb-3">
										<v-row>
											<v-col cols="12" sm="12" class="">
												<v-text-field label="Nomor NPWP" color="primary" class="input-regis" prepend-inner-icon="mdi-card-account-details" hide-details="auto" v-model="member_npwp" :disabled="(data.member_npwp || !isEditing) ? true : false" @keypress="onlyNumber"></v-text-field>
											</v-col>

											<v-col cols="12" class="d-none">
												<v-file-input
													id="uploadNpwp"
													hide-input
													accept="image/png,image/jpeg,image/jpg,image/x-png"
													prepend-icon="mdi-camera"
													label="Pilih gambar"
													v-model="npwp_image_upload"
													:rules="rules.filenpwp"
													@change="previewImageNpwp($event)"></v-file-input>
											</v-col>
											<v-col cols="12" class="d-flex align-center justify-space-between flex-column">
												<div style="display: block; position: relative; min-width: 160px; width: auto; max-width: 100%; margin: 0 auto;">
													<v-img max-width="100%" width="auto" height="180px" class="rounded-lg d-block mx-auto" :src="(npwp_image_url) ? npwp_image_url : 'assets/image/no-image.png'" style="border: 1px solid #ddd;"></v-img>
													<v-btn
														elevation="3"
														fab
														icon
														outlined
														raised
														rounded
														small
														class="btn-zoom"
														@click="dialogZoomOpen(npwp_image_url)"
														v-if="npwp_image_upload || data.member_npwp_image != ''"
													><v-icon color="#fff">mdi-magnify-plus-outline</v-icon></v-btn>
													<v-btn
														elevation="3"
														color="error"
														fab
														icon
														outlined
														raised
														rounded
														x-small
														style="position: absolute; top: -10px; right: -10px;background: #fff;"
														@click="clearNpwpImg"
														v-if="npwp_image_upload"
													><v-icon>mdi-close</v-icon></v-btn>
												</div>

												<v-btn
													depressed
													block
													outlined
													height="40px"
													:color="(!npwp_image_upload) ? (errorValidation['npwp_image'] && errorValidation['npwp_image'] !== undefined) ? 'red' : 'primary' : '#408285'"
													class="mt-4 text-capitalize"
													tabindex="13"
													:loading="btn_loading"
													:disabled="(npwp_image_upload || !isEditing) ? true : false"
													@click="openNpwpUpload"
													v-if="!data.member_npwp_image"
												>
													<v-icon>mdi-file-upload-outline</v-icon>
													<span class="pr-2 ms-2">Upload Foto NPWP</span>
												</v-btn>

												<small class="red--text mt-1" v-if="(errorValidation !== undefined && errorValidation['npwp_image'] !== undefined) || !npwp_image_upload">
													{{ (errorValidation !== undefined && errorValidation['npwp_image'] !== undefined) ? errorValidation['npwp_image'] : (!npwp_image_upload) ? '' : '' }}
												</small>
											</v-col>
										</v-row>
									</v-card>
								</v-col>
							</v-row>

							<v-dialog
								v-model="dialogZoom"
								max-width="600"
								color="#fff"
							>
								<v-img width="600px" :src="(imgzoom) ? imgzoom : 'assets/image/no-image.png'" class="d-block mx-auto" style="border: 1px solid #ddd;"></v-img>
							</v-dialog>
						</v-card>
						
						<v-card class="pa-3 elevation-0 rounded-xl pb-5 mb-3">
							<v-row>
								<v-col cols="12" sm="12" class="px-5 pb-0 mt-5">
									<v-textarea label="Alamat Lengkap" color="primary" class="input-regis" prepend-inner-icon="mdi-map-marker-plus" rows="2" counter="255" maxlenght="255" no-resize hide-details="auto" v-model="member_address" :rules="rules.input" :disabled="!isEditing"></v-textarea>
									<!-- :disabled="(member_address || !isEditing) ? true : false" -->
								</v-col>
								<v-col cols="12" sm="6" lg="4" class="px-5 pb-0">
									<!-- <pre>{{ provincesData }}</pre> -->
									<v-autocomplete label="Provinsi" no-data-text="Tidak ada data yang dapat ditampilkan" color="primary" item-color="primary" class="input-regis" prepend-inner-icon="mdi-map-marker" :items="provincesData" item-text="province_name" item-value="province_id" hide-details="auto" v-model="member_province_id" @change="changeProvince" :rules="rules.input" :disabled="!isEditing"></v-autocomplete>
								</v-col>
								<v-col cols="12" sm="6" lg="4" class="px-5 pb-0">
									<!-- <pre>{{ citiesData }}</pre> -->
									<v-autocomplete label="Kabupaten / Kota" no-data-text="Pilih provinsi terlebih dulu" color="primary" item-color="primary" class="input-regis" prepend-inner-icon="mdi-map-marker" :items="citiesData" item-text="city_name" item-value="city_id" hide-details="auto" v-model="member_city_id" :rules="rules.input" @change="changeCity" :disabled="!isEditing">
									</v-autocomplete>
								</v-col>
								<v-col cols="12" sm="6" lg="4" class="px-5">
									<!-- <pre>{{ member_subdistrict_id }}</pre> -->
									<v-autocomplete label="Kecamatan" no-data-text="Pilih kota terlebih dulu" color="primary" item-color="primary" class="input-regis" prepend-inner-icon="mdi-map-marker" :items="subdistrictsData" item-text="subdistrict_name" item-value="subdistrict_id" hide-details="auto" v-model="member_subdistrict_id" :rules="rules.input" :disabled="!isEditing"></v-autocomplete>
								</v-col>
							</v-row>
						</v-card>

						<v-card class="pa-3 elevation-0 rounded-xl pb-5 mb-3" v-if="false">
							<v-row>
								<v-col cols="12" sm="6" class="px-5 pb-0">
									<v-text-field label="Nama Ibu Kandung" color="primary" class="input-regis" prepend-inner-icon="mdi-account" hide-details="auto" v-model="member_mother_name" :disabled="!isEditing"></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" class="px-5 pb-0">
									<v-text-field label="Nama Ahli Waris" color="primary" class="input-regis" prepend-inner-icon="mdi-account" hide-details="auto" v-model="member_devisor_name" :disabled="!isEditing" @change="changeInputData"></v-text-field>
								</v-col>
								<v-col cols="12" sm="6" class="px-5">
									<v-text-field label="Hubungan Ahli Waris" color="primary" class="input-regis" prepend-inner-icon="mdi-account" hide-details="auto" v-model="member_devisor_relation" :disabled="!isEditing" @change="changeInputData"></v-text-field>
								</v-col>
							</v-row>
						</v-card>

						<v-card class="pa-3 elevation-0 rounded-xl pb-5 mb-3">
							<v-row>
								<v-col cols="12" sm="4" class="px-5 pb-0">
									<v-autocomplete label="Nama Bank" no-data-text="Tidak ada data yang dapat ditampilkan" color="primary" item-color="primary" class="input-regis" prepend-inner-icon="mdi-bank-outline" :items="banks" item-text="bank_name" item-value="bank_id" hide-details="auto" v-model="member_bank_id" :rules="rules.input" :disabled="((data.member_bank_id !== null && data.member_bank_id !== ''&& data.member_bank_id !== '0') || !isEditing) ? true : false" ></v-autocomplete>
								</v-col>
								<v-col cols="12" sm="4" class="px-5 pb-0">
									<v-text-field label="Nama Rekening" color="primary" class="input-regis" prepend-inner-icon="mdi-clipboard-account-outline" hide-details="auto" v-model="member_bank_account_name" :disabled="((data.member_bank_account_name !== null && data.member_bank_account_name !== '') || !isEditing) ? true : false"></v-text-field>
								</v-col>
								<v-col cols="12" sm="4" class="px-5">
									<v-text-field label="Nomor Rekening" color="primary" class="input-regis" prepend-inner-icon="mdi-credit-card-outline" hide-details="auto" v-model="member_bank_account_no" :disabled="((data.member_bank_account_no !== null && data.member_bank_account_no !== '') || !isEditing) ? true : false" @change="changeInputData" @keypress="onlyNumber"></v-text-field>
								</v-col>
							</v-row>
						</v-card>
					</v-form>
				</v-col>
			</v-row>
			<v-row class="mt-0 justify-center justify-sm-start">
				<v-col cols="6" sm="3" md="3" v-if="!isEditing">
					<v-btn height="45" depressed block color="primary" class="white--text rounded-xl text-capitalize" @click="isEditing = !isEditing">
						<v-icon>mdi-pencil</v-icon>
						<span class="pl-2 font-size-11 font-weight-bold">Ubah</span>
					</v-btn>
				</v-col>
				<v-col cols="6" sm="3" md="3" v-if="isEditing">
					<v-btn height="45" depressed block class="grey--text  rounded-xl text--darken-2 text-capitalize" color="grey lighten-2" :loading="btnLoadingProses" :disabled="btnLoadingProses" @click="cancelSave">
						<v-icon>mdi-close</v-icon>
						<span class="pl-2 font-size-11 font-weight-bold">Batal</span>
					</v-btn>
				</v-col>
				<v-col cols="6" sm="3" md="3" v-if="isEditing" class="pl-0">
					<v-btn height="45" depressed block color="primary" class="white--text rounded-xl text-capitalize" :loading="btnLoadingProses" :disabled="btnLoadingProses" @click="processInput">
						<v-icon>mdi-content-save-outline</v-icon>
						<span class="pl-2 font-size-11 font-weight-bold">Simpan</span>
					</v-btn>
				</v-col>
			</v-row>
		</v-col>

		<v-snackbar v-model="showSnack" color="red" timeout="5000" top right>
			{{ messageSnack }}
		</v-snackbar>

		<v-dialog
			v-model="dialogZoom"
			max-width="600"
		>
			<v-img width="600px" :src="(imgzoom) ? imgzoom : 'assets/image/no-image.png'" class="d-block mx-auto" style="border: 1px solid #ddd;"></v-img>
		</v-dialog>

		<v-dialog
			v-model="dialogOtp"
			max-width="520"
			persistent
		>
			<v-card>
				<v-card-text class="d-flex align-center justify-space-between py-4">
					<h3 class="">Kode OTP Keamanan</h3>
					<v-btn
            icon
            @click="cancelSaveDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
				</v-card-text>
				<v-card-text>
					<v-row>
						<v-col cols="12" class="text-center font-weight-bold mb-2">
							Masukkan 6 digit kode keamanan yang dikirim<br>melalui pesan WA Anda.
						</v-col>

						<v-col cols="12" class="text-center mb-2 px-5">
							<v-alert
								dense
								text
								:type="(!otpError) ? 'success' : 'error'"
								class="mb-50 text-left"
								transition="scale-transition"
								v-if="otpMessage !== ''"
							>
								{{ otpMessage }}
							</v-alert>

							<v-row class="px-5">
								<v-col cols="2 px-1">
									<v-text-field ref="otp0" v-model="otp[0]" @input="moveToNextField(0)" outlined autofocus  x-large single-line color="primary" maxlength="1" class="centered-input font-size-18 green--text" hide-details="auto" @keypress="onlyNumber"></v-text-field>
								</v-col>
								<v-col cols="2 px-1">
									<v-text-field ref="otp1" v-model="otp[1]" @input="moveToNextField(1)" outlined x-large single-line color="primary" maxlength="1" class="centered-input font-size-18 green--text" hide-details="auto" @keypress="onlyNumber"></v-text-field>
								</v-col>
								<v-col cols="2 px-1">
									<v-text-field ref="otp2" v-model="otp[2]" @input="moveToNextField(2)" outlined x-large single-line color="primary" maxlength="1" class="centered-input font-size-18 green--text" hide-details="auto" @keypress="onlyNumber"></v-text-field>
								</v-col>
								<v-col cols="2 px-1">
									<v-text-field ref="otp3" v-model="otp[3]" @input="moveToNextField(3)" outlined x-large single-line color="primary" maxlength="1" class="centered-input font-size-18 green--text" hide-details="auto" @keypress="onlyNumber"></v-text-field>
								</v-col>
								<v-col cols="2 px-1">
									<v-text-field ref="otp4" v-model="otp[4]" @input="moveToNextField(4)" outlined x-large single-line color="primary" maxlength="1" class="centered-input font-size-18 green--text" hide-details="auto" @keypress="onlyNumber"></v-text-field>
								</v-col>
								<v-col cols="2 px-1">
									<v-text-field ref="otp5" v-model="otp[5]" @input="moveToNextField(5)" outlined x-large single-line color="primary" maxlength="1" class="centered-input font-size-18 green--text" hide-details="auto" @keypress="onlyNumber"></v-text-field>
								</v-col>
							</v-row>
						</v-col>

						<v-col cols="12" class="text-center mb-2 px-5">
							<p class="mb-0">Belum menerima kode OTP?</p>
							<Timer :valDate="new Date(otpLastSent)" @action="changeTimer" class="font-weight-bold font-size-16 py-2" v-show="(this.otpCount == '1')"></Timer>
							<v-btn 
								text
								tile
								color="primary"
								class="py-0"
								:disabled="(this.otpCount == '1')"
								@click="getNewOTPCode"><v-icon dense class="mr-1">mdi-refresh</v-icon>Kirim Ulang Kode OTP</v-btn>
						</v-col>

						<v-col cols="12" class="text-center mb-2 px-5">
							<v-btn
								rounded
								color="primary"
								:loading="btnLoadingProses"
								:disabled="(otp.join('').length < 6) ? true : false"
								@click="save"
							>
								Simpan Perubahan
							</v-btn>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import Timer from './Timer';

export default {
	components: {
		Timer
	},
	data() {
		return {
			isEditing: false,
			btn_loading: false,
			dialogOtp: false,
			otp: [],
			otpError: false,
			otpMessage: '',
			otpCount: '',
			otpLastSent: null,
			otpTimer: null,
			loadign_otp_process: false,
			joinDate: false,
			bornDate: false,
			btnLoadingProses: false,
			isActiveMember: false,
			identity_image_upload: null,
			identity_image_url: '',
			npwp_image_upload: null,
			npwp_image_url: '',
			kk_image_upload: null,
			kk_image_url: '',
			dialogZoom: false,
			imgzoom: '',
			isHasNpwp: false,
			isHasKK: false,
			member_npwp: '',
			member_kk_no: '',
			member_identity_no: '',
			member_otp_code: '',

			member_name: '',
			member_email: '',
			member_mobilephone: '',
			member_gender: '',
			member_birth_place: '',
			member_birth_date: '',
			member_province_id: '',
			member_city_id: '',
			member_subdistrict_id: '',
			member_bank_id: '',
			member_bank_account_name: '',
			member_bank_account_no: '',
			member_address: '',
			member_mother_name: '',
			member_devisor_name: '',
			member_devisor_relation: '',
			rules: {
				input: [
				v => !!v || 'Tidak boleh kosong',
				],
				filenpwp: [
					v => (v && v.size < 3000000) || 'Ukuran foto npwp tidak boleh lebih dari 3 MB',
				],
				fileidentity: [
					v => (v && v.size < 3000000) || 'Ukuran foto identitas tidak boleh lebih dari 3 MB',
				],
				fileKk: [
					v => (v && v.size < 3000000) || 'Ukuran foto kartu keluarga tidak boleh lebih dari 3 MB',
				],
				email: [
				v => !!v || 'Tidak boleh kosong',
				v => ( v && !this.errorValidation.member_email ) || "Email sudah digunakan oleh pengguna lain",
				],
				phone: [
				v => !!v || 'Tidak boleh kosong',
				v => ( v && !this.errorValidation.member_mobilephone ) || "Nomor Handphone sudah digunakan oleh pengguna lain",
				],
				bank_no: [
				v => !!v || 'Tidak boleh kosong',
				v => ( v && !this.errorValidation.member_bank_account_no ) || "Nomor Rekening sudah digunakan oleh pengguna lain",
				],
			},
			showSnack: false,
			messageSnack: '',
			enctype: ''
		}
	},
	props: {
		data: { type: Object },
		provincesData: { type: Array },
		citiesData: { type: Array },
		subdistrictsData: { type: Array },
		banks: { type: Array },
	},
	computed: {
		...mapState('profil', ['errorValidation']),
		...mapState('opsi', ['cities']),
	},
	methods: {
		...mapActions('profil', ['getProfileMitra', 'editProfileMitra', 'getNewOTP']),
		...mapActions('opsi', ['getCity', 'getSubdistrict']),
		...mapMutations('profil', ['clearErrorValidation']),

		changeProvince() {
			this.getCity({province_id: this.member_province_id})
			this.member_city_id = ''
			this.member_subdistrict_id = ''
		},
		changeCity() {
			this.getSubdistrict({city_id: this.member_city_id})
			this.member_subdistrict_id = ''
		},
		customFilter (item, queryText) {
			const byName = item.city_name.toLowerCase()
			const byType = item.city_type.toLowerCase()
			const searchText = queryText.toLowerCase()

			return byName.indexOf(searchText) > -1 || byType.indexOf(searchText) > -1
		},
		changeInputData() {
			this.clearErrorValidation()
			this.$refs.formProfile.resetValidation()
		},
		async setDataProfile() {
			this.member_province_id = await this.data.member_province_id
			await this.getCity({province_id: this.member_province_id})
			
			this.member_city_id = await this.data.member_city_id
			await this.getSubdistrict({city_id: this.member_city_id})

			this.member_name = this.data.member_name
			this.member_email = this.data.member_email
			this.member_mobilephone = this.data.member_mobilephone
			this.member_gender = this.data.member_gender
			this.member_birth_place = this.data.member_birth_place
			this.member_birth_date = this.data.member_birth_date
			this.member_subdistrict_id = this.data.member_subdistrict_id
			this.member_bank_id = this.data.member_bank_id
			this.member_bank_account_name = this.data.member_bank_account_name
			this.member_bank_account_no = this.data.member_bank_account_no
			this.member_address = this.data.member_address
			// this.member_mother_name = this.data.member_mother_name
			// this.member_devisor_name = this.data.member_devisor_name
			// this.member_devisor_relation = this.data.member_devisor_relation

			this.identity_image_url = this.data.member_identity_image_url
			this.npwp_image_url = this.data.member_npwp_image_url
			this.kk_image_url = this.data.member_kk_image_url

			this.member_npwp = this.data.member_npwp
			this.member_kk_no = this.data.member_kk_no
			this.member_identity_no = this.data.member_identity_no

		},
		cancelSave() {
			this.isEditing = false
			this.identity_image_upload = null
			this.identity_image_url = ''
			this.npwp_image_upload = null
			this.npwp_image_url = ''
			this.kk_image_upload = null
			this.kk_image_url = ''
			this.member_otp_code = ''
			this.otpMessage = ''
			this.otpError = false
			this.otp = []
			this.btnLoadingProses = false
			this.getCity({province_id: this.data.member_province_id}).then(()=> {
				this.getSubdistrict({city_id: this.data.member_city_id}).then(()=> {
					this.setDataProfile()
				})
			})
		},

		cancelSaveDialog() {
			this.otpMessage = ''
			this.otpError = false
			this.otp = []
			this.dialogOtp = false
			this.btnLoadingProses = false
		},

		getNewOTPCode() {
			if (this.otpCount == '' || this.otpCount == '0') {
				this.btnLoadingProses = true
				this.getNewOTP()
					.then(()=> {
						this.otpLastSent = localStorage.getItem('mlmcore-otp-last')
						this.otpMessage = 'Kode otp keamanan telah berhasil dikirimkan.'
						this.otpError = false
						setTimeout(() => {
							this.otpMessage = ''
						}, 6000);
						this.btnLoadingProses = false
					})
					.catch((err) => {
						this.otpLastSent = localStorage.getItem('mlmcore-otp-last')
						this.otpMessage = (err.data.message !== undefined) ? err.data.message : ''
						this.otpError = true
						this.btnLoadingProses = false
					})
			}
		},

		changeTimer(val) {
			this.otpCount = val
		},
		
		async processInput() {
			this.dialogOtp = await true
			this.member_otp_code = await ''
			this.otp = await []
			this.otpMessage = await ''
			this.otpLastSent = localStorage.getItem('mlmcore-otp-last')
			this.getNewOTPCode()
			this.otpError = false
		},

		async save() {
			// if (this.$refs.formProfile.validate()) {
				this.btnLoadingProses = true
				if (this.otp.length > 0) this.member_otp_code = this.otp.join('')
				
				if (this.member_otp_code !== '') {
					this.dialogOtp = false
					let formData = new FormData()
					// formData.append('name', this.member_name)
					// formData.append('email', this.member_email)
					// formData.append('mobilephone', this.member_mobilephone)
					// formData.append('gender', this.member_gender)
					// formData.append('birth_place', this.member_birth_place)
					// formData.append('birth_date', this.member_birth_date)
					formData.append('otp_code', this.member_otp_code)
					
					if (this.member_address !== '') formData.append('address', this.member_address)
					if (this.member_province_id !== '') formData.append('province_id', ((this.member_province_id !== '' && this.member_province_id !== '0') ? this.member_province_id : ''))
					if (this.member_city_id !== '') formData.append('city_id', ((this.member_city_id !== '' && this.member_city_id !== '0') ? this.member_city_id : ''))
					if (this.member_subdistrict_id !== '') formData.append('subdistrict_id', ((this.member_subdistrict_id !== '' && this.member_subdistrict_id !== '0') ? this.member_subdistrict_id : '')) 
	
					if ((this.data.member_bank_name == '' || this.data.member_bank_name == null) && this.member_bank_id !== '') formData.append('bank_id', this.member_bank_id)
					if ((this.data.member_bank_account_name == '' || this.data.member_bank_account_name == null) && this.member_bank_account_name !== '') formData.append('bank_account_name', this.member_bank_account_name)
					if ((this.data.member_bank_account_no == '' || this.data.member_bank_account_no == null) && this.member_bank_account_no !== '') formData.append('bank_account_no', this.member_bank_account_no)
	
					if ((this.data.member_npwp == '' || this.data.member_npwp == null) && this.member_npwp !== '') formData.append('npwp', this.member_npwp)
					if ((this.data.member_kk_no == '' || this.data.member_kk_no == null) && this.member_kk_no !== '') formData.append('kk_no', this.member_kk_no)
					if ((this.data.member_identity_no == '' || this.data.member_identity_no == null) && this.member_identity_no !== '') formData.append('identity_no', this.member_identity_no)
					if ((this.data.member_npwp_image == '' || this.data.member_npwp_image == null) && this.npwp_image_url !== '') formData.append('npwp_image', (this.npwp_image_upload) ? this.npwp_image_upload : '')
					if ((this.data.member_kk_image == '' || this.data.member_kk_image == null) && this.kk_image_url !== '') formData.append('kk_image', (this.kk_image_upload) ? this.kk_image_upload : '')
					// if ((this.data.member_identity_image == '' || this.data.member_identity_image == null) && this.identity_image_url !== '') formData.append('identity_image', (this.identity_image_upload) ? this.identity_image_upload : '')
					formData.append('identity_image', (this.identity_image_upload) ? this.identity_image_upload : '')
	
					let counts = 0
					let str = ''
					this.enctype = ''
					for (const key of formData.values()) {
						str += window.btoa(key)
						counts++
					}
					
					this.enctype = str
					if (counts > 0) {
						await this.editProfileMitra(formData).then(() => {
							this.getProfileMitra()
							this.setDataProfile()
							
							this.btnLoadingProses = false
							this.isEditing = !this.isEditing
						}).catch(() => {
							this.btnLoadingProses = false
							this.$refs.formProfile.validate()
						})
					} else {
						this.btnLoadingProses = false
						this.messageSnack = 'Anda belum melakukan perubahan data, mohon periksa kembali data profil Anda.'
						this.showSnack = true
					}
				} else {
					this.dialogOtp = true
					this.otpMessage = 'Silahkan masukan otp dengan benar.'
					this.otpError = true
					this.$refs.otp0.focus()
					setTimeout(() => {
						this.otpMessage = ''
						this.otpError = false
					}, 6000);
					this.btnLoadingProses = false
				}
		},

		openNpwpUpload() {
			document.getElementById('uploadNpwp').click()
		},

		openIdentityUpload() {
			document.getElementById('uploadIdentity').click()
		},
		
		openKkUpload() {
			document.getElementById('uploadKK').click()
		},

		clearNpwpImg() {
			this.npwp_image_upload = null
			this.npwp_image_url = ''
			this.errorValidation['npwp_image'] = null
		},

		clearIdentityImg() {
			this.identity_image_upload = null
			this.identity_image_url = ''
			this.errorValidation['identity_image'] = null
		},

		clearKkImg() {
			this.kk_image_upload = null
			this.kk_image_url = ''
			this.errorValidation['kk_image'] = null
		},

		previewImageNpwp(event) {
			if (event) {
				if (event.size > 3000000) {
					this.errorValidation['npwp_image'] = 'Ukuran foto Npwp tidak boleh lebih dari 3 MB'
					this.npwp_image_upload = null
					this.btn_disabled = true
				} else {
					this.npwp_image_url = URL.createObjectURL(this.npwp_image_upload)
					this.btn_disabled = false
					this.errorValidation['identity_image'] = null
				}
			} else {
				this.npwp_image_url = null
			}
		},

		previewImageIdentity(event) {
			if (event && event.type != 'application/pdf') {
				if (event.size > 3000000) {
					this.errorValidation['identity_image'] = 'Ukuran foto Npwp tidak boleh lebih dari 3 MB'
					this.identity_image_upload = null
					this.btn_disabled = true
				} else {
					this.identity_image_url = URL.createObjectURL(this.identity_image_upload)
					this.btn_disabled = false
					this.errorValidation['identity_image'] = null
				}
			} else {
				this.identity_image_url = null
			}
		},

		previewImageKk(event) {
			if (event) {
				if (event.size > 3000000) {
					this.errorValidation['kk_image'] = 'Ukuran foto Npwp tidak boleh lebih dari 3 MB'
					this.kk_image_upload = null
					this.btn_disabled = true
				} else {
					this.kk_image_url = URL.createObjectURL(this.kk_image_upload)
					this.btn_disabled = false
					this.errorValidation['identity_image'] = null
				}
			} else {
				this.kk_image_url = null
			}
		},

		dialogZoomOpen(img) {
			this.imgzoom = img
			this.dialogZoom = true
		},

		moveToNextField(index) {
      const nextIndex = index + 1
      if (this.$refs['otp' + nextIndex] !== undefined) this.$refs['otp' + nextIndex].focus()
    },

	},
	async mounted() {
		this.setDataProfile()
		this.otpLastSent = localStorage.getItem('mlmcore-otp-last')
	},
};
</script>

<style lang="scss" scoped>
	.icon-upload-image {
		margin-top: -3.3rem !important;
		margin-left: 9.5rem !important;
	}

	.btn-zoom {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background: rgba(0,0,0,0.4);

		&:hover, &:focus {
			background: rgba(0,0,0,0.6);
		}
	}
</style>